import {
  changeCustomerWalletStatusApiCall,
  createCustomerWalletApiCall,
  getCustomerWalletApiCall,
  getProviderCustomersWalletsApiCall,
  getWalletEventsApiCall,
  reimburseIntoCustomerWalletApiCall,
  topUpWalletApiCall,
  updateCustomerWalletApiCall,
} from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';
import { DEFAULT_END_TIME, DEFAULT_START_TIME } from '..';

export const PROVIDER_CUSTOMERS_WALLETS = { entity: 'PROVIDER_CUSTOMERS_WALLETS', action: Action.GET_MANY };
export const CREATE_CUSTOMER_WALLET = { entity: 'CREATE_CUSTOMER_WALLET', action: Action.CREATE };
export const TOGGLE_WALLET_STATUS = { entity: 'TOGGLE_WALLET_STATUS', action: Action.UPDATE };
export const WALLET_EVENTS = { entity: 'WALLET_EVENTS', action: Action.GET_MANY };
export const CUSTOMER_WALLET = { entity: 'CUSTOMER_WALLET', action: Action.GET };
export const UPDATE_WALLET = { entity: 'CUSTOMER_WALLET', action: Action.UPDATE };
export const REIMBURSE_INTO_WALLET = { entity: 'REIMBURSE_INTO_WALLET', action: Action.UPDATE };
export const TOPUP_WALLET = { entity: 'TOPUP_WALLET', action: Action.CREATE };

//WALLETS
export const getProviderCustomersWallets =
  (silent = false) =>
  async dispatch =>
    execute(dispatch, () => getProviderCustomersWalletsApiCall({ user: ['name', 'email'] }), PROVIDER_CUSTOMERS_WALLETS, null, null, silent);
export const changeCustomerWalletStatus = (id, status) => async dispatch =>
  execute(dispatch, () => changeCustomerWalletStatusApiCall({ id, status }), TOGGLE_WALLET_STATUS);
export const createCustomerWallet = data => async dispatch => {
  const { startDate, endDate, ...rest } = data;
  const request = { ...rest, startDate: `${startDate}T${DEFAULT_START_TIME}`, endDate: `${endDate}T${DEFAULT_END_TIME}` };
  execute(dispatch, () => createCustomerWalletApiCall({ request }), CREATE_CUSTOMER_WALLET);
};
export const updateCustomerWallet = request => async dispatch => execute(dispatch, () => updateCustomerWalletApiCall({ request }), UPDATE_WALLET);
// Wallet top-up tracked as an order (credit added + cash collected + method).
export const topUpWallet = request => async dispatch => execute(dispatch, () => topUpWalletApiCall({ request }), TOPUP_WALLET);
export const getCustomerWallet = customerId => async dispatch => execute(dispatch, () => getCustomerWalletApiCall({ customerId }), CUSTOMER_WALLET);

//EVENTS
export const getWalletEvents = id => async dispatch => execute(dispatch, () => getWalletEventsApiCall({ id }), WALLET_EVENTS);
export const reimburseIntoCustomerWallet = (userId, providerId, amount, eventId, type) => async dispatch =>
  execute(dispatch, () => reimburseIntoCustomerWalletApiCall({ userId, providerId, amount, eventId, type }), REIMBURSE_INTO_WALLET);

export const walletsReducer = {
  all: basicReducer(PROVIDER_CUSTOMERS_WALLETS),
  create: basicReducer(CREATE_CUSTOMER_WALLET),
  status: basicReducer(TOGGLE_WALLET_STATUS),
  events: basicReducer(WALLET_EVENTS),
  customer: basicReducer(CUSTOMER_WALLET),
  update: basicReducer(UPDATE_WALLET),
  reimburse: basicReducer(REIMBURSE_INTO_WALLET),
  topup: basicReducer(TOPUP_WALLET),
};
